import { render } from "./RegistrationStart.vue?vue&type=template&id=1ba8560e"
import script from "./RegistrationStart.vue?vue&type=script&lang=js"
export * from "./RegistrationStart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__